(function ($) {
  supercatColumnsV1 = {
    formatter: $('.supercat-columns-v1')
  };

  Drupal.behaviors.supercatColumnsV1 = {
    get: function (key) {
      return supercatColumnsV1[key];
    },

    set: function (key, val) {
      supercatColumnsV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var columns = thisFormatter.find('.column');

        Drupal.cl.responsiveColumns(columns);
      });
    }
  };
})(jQuery);
